 function manageShippingCookie(sku,name,shippingTime,state) {
   
          const cookieName = 'gbm_cart_shipping';
          let items = [];
          // 1. Get and parse the cookie in one go.
          try {
            items = JSON.parse(decodeURIComponent(document.cookie.split(`${cookieName}=`)[1]?.split(';')[0])) || [];
          } catch {
            items = [];
          }
          if (!Array.isArray(items)) items = []; // Final safety check
        
          const actions = {
              add: (arr,sku,name,shippingTime) => {
                
                const index =  arr.length>0 ? arr.findIndex(i => i.sku === sku) : -1;
            
                // Caso A: El producto NO existe (índice es -1).
                // Devolvemos un nuevo array con el producto añadido.
                if (  index === -1) {
                  return [...arr, { sku,name, shippingTime }];
                }
            
                // El producto SÍ existe. Ahora comparamos el shippingTime.
                const existingItem = arr[index];
            
                // Caso B: El shippingTime es idéntico.
                // Devolvemos el array original sin cambios.
                if (existingItem.shippingTime === shippingTime) {
                  return arr;
                }
            
                // Caso C: El shippingTime es diferente.
                // Usamos .map() para crear un nuevo array con el valor actualizado.
                return arr.map(item =>
                  item.sku === sku ? { ...item, shippingTime } : item
                );
              },
              // (Actualizado a 'sku' para consistencia)
              remove: (arr,sku,name,shippingTime) => arr.filter(i => i.name !== name),
            upload: (arr,sku,name,shippingTime) =>{
              
            const longestShippingTime = items.reduce((bestOption, product) => {
            const currentMaxDays = Math.max(...(product.shippingTime.match(/\d+/g) || [0]));
            return currentMaxDays > bestOption.days ? {days: currentMaxDays, time: product.shippingTime} : bestOption;
                    }, {days: 0, time: ''}).time;
              
              updateShopifyCustomInfo(longestShippingTime);
              
            },
        };
          items = actions[state] ? actions[state](items,sku,name,shippingTime) : items;
        
          // 3. Set the updated cookie with a shorthand for expiration.
        if(state != 'upload'){
          const date = new Date();
          date.setTime(date.getTime() + 7 * 864e5); // 864e5 is a short way to write 24*60*60*1000
          document.cookie = `${cookieName}=${encodeURIComponent(JSON.stringify(items))};expires=${date.toUTCString()};path=/`;
        }
          
}
function equalizeHeights(selectors) {
                                  selectors.forEach(function(selector) {
                                      function recalculateHeights() {
                                          let maxHeight = 0;
                                          const elements = document.querySelectorAll(selector);
                                          elements.forEach(function(element) {
                                              const currentHeight = element.offsetHeight;
                                              maxHeight = Math.max(maxHeight, currentHeight);
                                          });
                                          elements.forEach(function(element) {
                                              element.style.height = maxHeight + 'px';
                                          });
                                      }

                                      // Calcular las alturas iniciales
                                      recalculateHeights();

                                      // Asignar un event listener para recalcular las alturas al redimensionar la ventana
                                      window.addEventListener('resize', recalculateHeights);
                                  });
                              }
                  function getCookie(name) {
                const nameEQ = name + "=";
                const ca = document.cookie.split(';');
                for(let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) == 0) {
                        return decodeURIComponent(c.substring(nameEQ.length, c.length));
                    }
                }
                return null;
            }

function updateShopifyCustomInfo(cookieData){
              const data = { note:  cookieData};
              
              fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
              })
              .then(response => response.json())
              .then(cart => {
                console.log('Atributo del carrito actualizado con la info de la cookie:', cart);
              })
              .catch((error) => {
                console.error('Error:', error);
              });
            }
function drawerListener(selector, callback, delay = 0) {
    setTimeout(() => {
        const element = $(selector);
        if (element.length) {
            callback(element);
            return;
        }

        const observer = new MutationObserver((mutations, obs) => {
            const elementFound = $(selector);
            if (elementFound.length) {
                obs.disconnect();
                callback(elementFound);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }, delay);
}